import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ProductCard } from '../components/ProductCard';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProductsPage = ({ onAuthClick }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState('all');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const params = category !== 'all' ? { category } : {};
        const res = await axios.get(`${API}/products`, { params });
        setProducts(res.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [category]);

  const categories = ['all', 'Fire Cider'];

  return (
    <div className="paper-texture min-h-screen">
      {/* Header */}
      <div className="bg-surface py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="font-accent text-xl text-primary">Browse</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-secondary mt-2" data-testid="products-title">Our Products</h1>
          <p className="text-muted-foreground mt-4 max-w-2xl">
            Discover our range of handcrafted fire ciders, each made with the finest organic ingredients 
            to support your wellness journey.
          </p>
        </div>
      </div>

      {/* Filters & Products */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Filters */}
        <div className="flex items-center justify-between mb-8">
          <p className="text-muted-foreground" data-testid="products-count">
            {products.length} product{products.length !== 1 ? 's' : ''}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-sm text-muted-foreground">Category:</span>
            <Select value={category} onValueChange={setCategory}>
              <SelectTrigger className="w-40" data-testid="category-filter">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {categories.map((cat) => (
                  <SelectItem key={cat} value={cat} data-testid={`category-${cat}`}>
                    {cat === 'all' ? 'All Products' : cat}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="bg-surface rounded-lg h-96 animate-pulse"></div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-muted-foreground text-lg">No products found</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} onAuthRequired={onAuthClick} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
